var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaginationRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2767 9.01752L5.54545 2.979C5.52525 2.96309 5.50097 2.95321 5.47541 2.95048C5.44984 2.94775 5.42402 2.95229 5.40092 2.96357C5.37782 2.97485 5.35837 2.99243 5.3448 3.01427C5.33123 3.03611 5.3241 3.06133 5.32422 3.08704V4.41274C5.32422 4.49677 5.36367 4.57738 5.42884 4.62883L11.6028 9.4497L5.42884 14.2706C5.36195 14.322 5.32422 14.4026 5.32422 14.4867V15.8124C5.32422 15.9273 5.45628 15.9907 5.54545 15.9204L13.2767 9.88188C13.3424 9.83062 13.3955 9.76506 13.4321 9.69017C13.4687 9.61528 13.4877 9.53304 13.4877 9.4497C13.4877 9.36636 13.4687 9.28412 13.4321 9.20923C13.3955 9.13434 13.3424 9.06878 13.2767 9.01752Z",
    fill: "black",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRight);
export default __webpack_public_path__ + "static/media/paginationRight.a756c8ad79fd5d90edc75f8f81795e73.svg";
export { ForwardRef as ReactComponent };